<template>
  <!-- 페이지별 내용 -->
  <main id="main" class="has-path">
    <router-view :key="viewKey" />
  </main>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const reuse = route.meta.reuse ?? true;

const viewKey = computed(() => (reuse ? route.name : route.fullPath));
</script>
